var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.devcDef }
        },
        [
          _vm.realDevcDef != null && _vm.realDevcDef
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("关联资产定义")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "assetDefInnerCode",
                          rules: {
                            validator: _vm.validateItem,
                            trigger: "change"
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x bottom-line",
                          attrs: { disabled: "", type: "text" },
                          model: {
                            value: _vm.devcDef.assetDefInnerCode,
                            callback: function($$v) {
                              _vm.$set(_vm.devcDef, "assetDefInnerCode", $$v)
                            },
                            expression: "devcDef.assetDefInnerCode"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          attrs: { title: "选择" },
                          on: {
                            click: function($event) {
                              _vm.selectDevcDefDlg()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("名称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "name",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: {
                        disabled: _vm.defId != null || _vm.buildFlag,
                        type: "text"
                      },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.name,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "name", $$v)
                        },
                        expression: "devcDef.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("型号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "model",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: {
                        disabled: _vm.defId != null || _vm.buildFlag,
                        type: "text"
                      },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.model,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "model", $$v)
                        },
                        expression: "devcDef.model"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("规格")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "fixedSpec",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: {
                        disabled: _vm.defId != null || _vm.buildFlag,
                        type: "text"
                      },
                      on: { change: _vm.titleChange },
                      model: {
                        value: _vm.devcDef.fixedSpec,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "fixedSpec", $$v)
                        },
                        expression: "devcDef.fixedSpec"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [
                _vm._v("组装件描述全称")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "title",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      model: {
                        value: _vm.devcDef.title,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "title", $$v)
                        },
                        expression: "devcDef.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("维保分组")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "devcGroupId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", filterable: "" },
                        on: { change: _vm.changeDevcGroup },
                        model: {
                          value: _vm.devcDef.devcGroupId,
                          callback: function($$v) {
                            _vm.$set(_vm.devcDef, "devcGroupId", $$v)
                          },
                          expression: "devcDef.devcGroupId"
                        }
                      },
                      _vm._l(_vm.devcGroupList, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.fullName, value: item.id }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("分类")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "catName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.devcDef.catName,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "catName", $$v)
                        },
                        expression: "devcDef.catName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.selectCatDlg()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("品牌")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "brandName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.devcDef.brandName,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "brandName", $$v)
                        },
                        expression: "devcDef.brandName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.selectBrandDlg()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("定义编码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "innerCode",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "text" },
                      model: {
                        value: _vm.devcDef.innerCode,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "innerCode", $$v)
                        },
                        expression: "devcDef.innerCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("单位")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "theUnit",
                      rules: { validator: _vm.validateItem, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { disabled: _vm.defId != null, type: "text" },
                      model: {
                        value: _vm.devcDef.theUnit,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "theUnit", $$v)
                        },
                        expression: "devcDef.theUnit"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group top" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("图片")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-file-upload", {
                  attrs: {
                    fileFor: "image-misc",
                    fileGroup: "image-misc",
                    onBeforeUpload: _vm.onBeforeUpload,
                    onProgress: _vm.onProgress,
                    onDone: _vm.onUploadDone,
                    multipleFile: false
                  }
                }),
                _vm._v(" "),
                _vm.imgFile != null
                  ? _c("div", { staticClass: "file-area clearfix" }, [
                      _vm.imgFile.fileBrowseUrl != null &&
                      _vm.imgFile.fileBrowseUrl != ""
                        ? _c(
                            "span",
                            [
                              _c("swb-file-item", {
                                attrs: {
                                  fileUuid: _vm.imgFile.fileUuid,
                                  fileBrowseUrl: _vm.imgFile.fileBrowseUrl,
                                  deletable: true,
                                  onDelete: _vm.removeUpload
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3facdea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3facdea8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/asmblAcc/AsmblAccDefSave.vue
// module id = 2421
// module chunks = 0